import { useGetReportByEmployee } from '../services/api';
import { ReportsTableSimple } from './ReportsTableSimple';

export const EmployeeReportTable: React.FC<{ employeeId: number }> = ({ employeeId }) => {
  const { data, error, isLoading } = useGetReportByEmployee({ employeeId });
  return <ReportsTableSimple data={data} isLoading={isLoading} error={error} />;
};
